import { useMutation } from "react-query";
import actionService from "../../services/actionService";

const useAddActionComment = () => useMutation(actionService.addActionComment)

export default useAddActionComment;